import { useState } from "react";
import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage } from "@/components/mobile/parts";
import { EmpresaTab } from "@/components/mobile/config/EmpresaTab";
import { ImpressaoTab } from "@/components/mobile/config/ImpressaoTab";
import { cn } from "@/lib/utils";

const TABS = [["empresa", "Empresa"], ["impressao", "Impressão"]];

function ConfigTabs({ value, onChange }) {
  return (
    <div className="sticky top-14 z-20 grid grid-cols-2 bg-[#1565c0] text-white shadow-md shadow-blue-900/20" data-testid="m-config-tabs">
      {TABS.map(([k, label]) => (
        <button key={k} onClick={() => onChange(k)} data-testid={`m-config-tab-${k}`}
          className={cn("relative py-3 text-[15px] font-semibold transition-colors", value === k ? "text-white" : "text-white/60")}>
          {label}
          <span className={cn("absolute inset-x-6 bottom-0 h-1 rounded-t-full bg-white transition-opacity", value === k ? "opacity-100" : "opacity-0")} />
        </button>
      ))}
    </div>
  );
}

export default function MConfig() {
  const [tab, setTab] = useState("empresa");
  return (
    <>
      <MTopBar title="Configurações" back />
      <ConfigTabs value={tab} onChange={setTab} />
      <MPage>{tab === "empresa" ? <EmpresaTab /> : <ImpressaoTab />}</MPage>
    </>
  );
}
